// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/chunks/" + chunkId + "." + {189: "ebd4356d",583: "d7436d9e",}[chunkId] + ".js"
}